import { RG_TYPE, isInRange } from "@project-rouge/rg-core";
import { getRgObjectsOfType, isPolygonClosed } from "@project-rouge/rg-three";
import { PerfStopwatch } from "./index40.js";
import { pipeAddCornerCores } from "./index87.js";
import { pipeAddCorridors } from "./index88.js";
import { pipeAddFacade } from "./index89.js";
import { pipeAddMuscles } from "./index90.js";
import { pipeAddOpenings } from "./index91.js";
import { pipeAddPlots } from "./index92.js";
import { pipeAddPodium } from "./index95.js";
import { pipeAddPodiumEmptySpaces } from "./index93.js";
import { pipeAddPodiumGlazing } from "./index94.js";
import { pipeAddRoofAndParapet } from "./index96.js";
import { pipeAddTechSpaces } from "./index97.js";
import { pipeAggNmcs } from "./index98.js";
import { pipeCalcAnatomyCores } from "./index99.js";
import { pipeCalcAnatomyEntrances } from "./index100.js";
import { pipeClearZone } from "./index101.js";
import { pipeFilter } from "./index102.js";
import { pipeGeneratePolygons } from "./index103.js";
import { pipeMatchFloors } from "./index104.js";
import { pipeRemoveEmptyBuildings } from "./index105.js";
import { pipeResize } from "./index106.js";
import { pipeSetBuildingIndexes } from "./index107.js";
import { pipeSetLevelData } from "./index108.js";
import { pipeTailor } from "./index109.js";
import { RgPipes } from "./index5.js";
const RunPipeline = ({
  obj,
  aggProps,
  buildingIds,
  from = RgPipes.Filter,
  to = RgPipes.SetBuildingIndexes,
  briefIndex,
  cache = []
}) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t, _u, _v, _w;
  aggProps = {
    ...aggProps,
    // remove frozen zones from `aggProps`
    zones: Object.fromEntries(
      Object.entries(aggProps.zones).filter((z) => !z[1].frozen)
    ),
    dataset: {
      // override dataset
      ...aggProps.dataset,
      aggConfig: {
        ...aggProps.dataset.aggConfig,
        face2FaceSeparation: aggProps.face2FaceSeparation ?? aggProps.dataset.aggConfig.face2FaceSeparation,
        face2SideSeparation: aggProps.face2SideSeparation ?? aggProps.dataset.aggConfig.face2SideSeparation
      }
    }
  };
  const stopwatch = {
    all: new PerfStopwatch()
  };
  const sites = getRgObjectsOfType(obj, RG_TYPE.Site);
  if (sites.some((s) => !isPolygonClosed(s.data.polygon)))
    throw new Error("polygon needs to be closed");
  let mainThreads;
  let mainFrozenThreads;
  const techData = [];
  if (briefIndex !== void 0 && isInRange(RgPipes.Filter, from, to)) {
    const sw = stopwatch[_a = RgPipes.Filter] || (stopwatch[_a] = new PerfStopwatch());
    sw.resume();
    [, aggProps] = pipeFilter([obj, { aggProps, buildingIds, cache, briefIndex }]);
    sw.pause();
  }
  if (isInRange(RgPipes.ClearZone, from, to)) {
    const sw = stopwatch[_b = RgPipes.ClearZone] || (stopwatch[_b] = new PerfStopwatch());
    sw.resume();
    pipeClearZone([obj, { aggProps }]);
    sw.pause();
  }
  if (isInRange(RgPipes.AddPlots, from, to)) {
    const sw = stopwatch[_c = RgPipes.AddPlots] || (stopwatch[_c] = new PerfStopwatch());
    sw.resume();
    const [, tailorData] = pipeAddPlots([obj, { aggProps, optimise: aggProps.optimisePlots }]);
    mainThreads = tailorData.mainThreads;
    mainFrozenThreads = tailorData.mainFrozenThreads;
    sw.pause();
  }
  if (isInRange(RgPipes.SkeletonTailorAnatomy, from, to)) {
    const sw = stopwatch[_d = RgPipes.SkeletonTailorAnatomy] || (stopwatch[_d] = new PerfStopwatch());
    sw.resume();
    if (mainThreads === void 0 || mainThreads.length === 0) {
      const [, tailorData] = pipeTailor([obj, { aggProps }]);
      mainThreads = tailorData.mainThreads;
      mainFrozenThreads = tailorData.mainFrozenThreads;
    }
    sw.pause();
  }
  if (isInRange(RgPipes.AddMuscles, from, to)) {
    const sw = stopwatch[_e = RgPipes.AddMuscles] || (stopwatch[_e] = new PerfStopwatch());
    sw.resume();
    pipeAddMuscles([obj, { aggProps, buildingIds }]);
    sw.pause();
  }
  if (isInRange(RgPipes.CalcAnatomyCores, from, to)) {
    const sw = stopwatch[_f = RgPipes.CalcAnatomyCores] || (stopwatch[_f] = new PerfStopwatch());
    sw.resume();
    pipeCalcAnatomyCores([obj, { aggProps, buildingIds }]);
    sw.pause();
  }
  if (isInRange(RgPipes.CalcAnatomyEntrances, from, to)) {
    const sw = stopwatch[_g = RgPipes.CalcAnatomyEntrances] || (stopwatch[_g] = new PerfStopwatch());
    sw.resume();
    pipeCalcAnatomyEntrances([obj, { aggProps, buildingIds }]);
    sw.pause();
  }
  if (isInRange(RgPipes.AggNmcs, from, to)) {
    const sw = stopwatch[_h = RgPipes.AggNmcs] || (stopwatch[_h] = new PerfStopwatch());
    sw.resume();
    pipeAggNmcs([obj, { aggProps, buildingIds }]);
    sw.pause();
  }
  if (isInRange(RgPipes.AddCornerCores, from, to)) {
    const sw = stopwatch[_i = RgPipes.AddCornerCores] || (stopwatch[_i] = new PerfStopwatch());
    sw.resume();
    pipeAddCornerCores([obj, { aggProps, buildingIds }]);
    sw.pause();
  }
  if (isInRange(RgPipes.AddCorridors, from, to)) {
    const sw = stopwatch[_j = RgPipes.AddCorridors] || (stopwatch[_j] = new PerfStopwatch());
    sw.resume();
    pipeAddCorridors([obj, { aggProps, buildingIds }]);
    sw.pause();
  }
  if (isInRange(RgPipes.SetLevelData, from, to)) {
    const sw = stopwatch[_k = RgPipes.SetLevelData] || (stopwatch[_k] = new PerfStopwatch());
    sw.resume();
    pipeSetLevelData([obj, { aggProps, buildingIds }]);
    sw.pause();
  }
  if (isInRange(RgPipes.AddPodium, from, to)) {
    const sw = stopwatch[_l = RgPipes.AddPodium] || (stopwatch[_l] = new PerfStopwatch());
    sw.resume();
    pipeAddPodium([obj, { aggProps, buildingIds }]);
    sw.pause();
  }
  if (isInRange(RgPipes.AddTechSpaces, from, to)) {
    const sw = stopwatch[_m = RgPipes.AddTechSpaces] || (stopwatch[_m] = new PerfStopwatch());
    sw.resume();
    pipeAddTechSpaces([obj, { aggProps, buildingIds, techData }]);
    sw.pause();
  }
  if (isInRange(RgPipes.RemoveEmptyBuildings, from, to)) {
    const sw = stopwatch[_n = RgPipes.RemoveEmptyBuildings] || (stopwatch[_n] = new PerfStopwatch());
    sw.resume();
    pipeRemoveEmptyBuildings([obj, void 0]);
    sw.pause();
  }
  if (isInRange(RgPipes.Resize, from, to)) {
    const sw = stopwatch[_o = RgPipes.Resize] || (stopwatch[_o] = new PerfStopwatch());
    sw.resume();
    pipeResize([obj, { aggProps, buildingIds }]);
    sw.pause();
  }
  if (isInRange(RgPipes.MatchFloors, from, to)) {
    const sw = stopwatch[_p = RgPipes.MatchFloors] || (stopwatch[_p] = new PerfStopwatch());
    sw.resume();
    pipeMatchFloors([obj, { aggProps, buildingIds }]);
    sw.pause();
  }
  if (isInRange(RgPipes.AddPodiumEmptySpaces, from, to)) {
    const sw = stopwatch[_q = RgPipes.AddPodiumEmptySpaces] || (stopwatch[_q] = new PerfStopwatch());
    sw.resume();
    pipeAddPodiumEmptySpaces([obj, { aggProps, buildingIds }]);
    sw.pause();
  }
  if (isInRange(RgPipes.AddOpenings, from, to)) {
    const sw = stopwatch[_r = RgPipes.AddOpenings] || (stopwatch[_r] = new PerfStopwatch());
    sw.resume();
    pipeAddOpenings([obj, { aggProps, buildingIds }]);
    sw.pause();
  }
  if (isInRange(RgPipes.AddRoofAndParapet, from, to)) {
    const sw = stopwatch[_s = RgPipes.AddRoofAndParapet] || (stopwatch[_s] = new PerfStopwatch());
    sw.resume();
    pipeAddRoofAndParapet([obj, { aggProps, buildingIds }]);
    sw.pause();
  }
  if (isInRange(RgPipes.AddFacade, from, to)) {
    const sw = stopwatch[_t = RgPipes.AddFacade] || (stopwatch[_t] = new PerfStopwatch());
    sw.resume();
    pipeAddFacade([obj, { aggProps, buildingIds }]);
    sw.pause();
  }
  if (isInRange(RgPipes.AddPodiumGlazing, from, to)) {
    const sw = stopwatch[_u = RgPipes.AddPodiumGlazing] || (stopwatch[_u] = new PerfStopwatch());
    sw.resume();
    pipeAddPodiumGlazing([obj, { aggProps, buildingIds }]);
    sw.pause();
  }
  if (isInRange(RgPipes.GeneratePolygons, from, to)) {
    const sw = stopwatch[_v = RgPipes.GeneratePolygons] || (stopwatch[_v] = new PerfStopwatch());
    sw.resume();
    pipeGeneratePolygons([obj, { aggProps, buildingIds }]);
    sw.pause();
  }
  if (isInRange(RgPipes.SetBuildingIndexes, from, to)) {
    const sw = stopwatch[_w = RgPipes.SetBuildingIndexes] || (stopwatch[_w] = new PerfStopwatch());
    sw.resume();
    pipeSetBuildingIndexes([obj, void 0]);
    sw.pause();
  }
  stopwatch.all.pause();
  const duration = {
    ...Object.fromEntries(
      Object.entries(stopwatch).map(([pipe, sw]) => [pipe, sw.elapsed * 1e-3])
    )
  };
  return { obj, cache, meta: { mainThreads, mainFrozenThreads, techData, duration } };
};
export {
  RunPipeline
};
//# sourceMappingURL=index6.js.map
